import { useEffect } from "react";

function setMeta(name, content, attr = "name") {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

export function useSEO({ title, description, keywords, ogImage }) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) setMeta("description", description);
        if (keywords) setMeta("keywords", keywords);
        if (title) setMeta("og:title", title, "property");
        if (description) setMeta("og:description", description, "property");
        if (ogImage) setMeta("og:image", ogImage, "property");
    }, [title, description, keywords, ogImage]);
}
